<script setup>
import { defineProps, defineEmits } from "vue";
import IconMessageNotify from "@/assets/icons/IconMessageNotify.vue";
import IconCross from "@/assets/icons/IconCross.vue";

defineProps({
  text: {
    type: String,
    default: ""
  },
  useCrossIcon: {
    type: Boolean,
    default: true
  },
  crossIconTooltipText: {
    type: String,
    default: "Больше не показывать"
  }
});

const emit = defineEmits(["close-notify"]);
</script>

<template>
  <div class="notify-alert">
    <slot name="icon">
      <IconMessageNotify class="notify-alert__icon notify-alert__icon--alert" />
    </slot>
    <span class="notify-alert__text">
      <slot>{{ text }}</slot>
    </span>
    <IconCross
      v-if="useCrossIcon"
      v-tooltip:bottom-right="crossIconTooltipText"
      class="notify-alert__icon notify-alert__icon--cross"
      @click="emit('close-notify')"
    />
  </div>
</template>

<style scoped lang="scss">
.notify-alert {
  display: flex;
  gap: 10px;
  border-radius: 8px;
  padding: 10px;
  background-color: var(--blue-blue20);

  &__text {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: var(--text-text-main);
  }

  &__icon {
    &--cross {
      margin-left: auto;
      cursor: pointer;
      color: var(--icon-icon-secondary);
      min-width: 14px;
      min-height: 14px;

      &:hover {
        color: var(--icon-icon-on);
      }
    }

    &--alert {
      color: var(--icon-icon-on);
      min-width: 20px;
      min-height: 20px;
    }
  }
}
</style>